export default "__VITE_ASSET__Bbz2wLlf__"